export const getCurrentElapsed = () => (process.env.NODE_ENV === 'test' ? 0 : performance.now());

export const momentLocaleCustomizations = {
  weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'], // short week days for BR
};

export const getElapsedTime = (startTime, endTime) => {
  const diffMs = endTime - startTime;
  const totalMinutes = Math.floor(diffMs / (1000 * 60));

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours}h${String(minutes).padStart(2, '0')}min`;
};
